import App from 'app/app.js';
import 'app/store/LooksStore.js';
import 'app/store/ProductCatalogStore.js';
import 'app/store/VisualMerchandiseStore.js';
import 'app/store/MessageStore.js';
import 'app/store/SelectionTemplateDataStore.js';

import 'app/action/ActiveJobChangedAction.js';

import 'app/action/SessionTimeoutAction.js';
import 'app/action/ResetJobAction.js';
import 'app/action/EmptyCartAction.js';
import 'app/action/JobLoadedAction.js';
import 'app/action/DeserializeAction.js';
import 'app/service/StorageService.js';
import 'app/action/LogoutSuccessAction.js';
import 'app/store/ContentStore.js';

// eslint-disable-next-line max-lines-per-function
function JobStore(
  MessageStore,
  LooksStore,
  ProductCatalogStore,
  VisualMerchandiseStore,
  SelectionTemplateDataStore,
  SessionTimeoutAction,
  LogoutSuccessAction,
  JobLoadedAction,
  DeserializeAction,
  ActiveJobChangedAction,
  ResetJobAction,
  EmptyCartAction,
  StorageService,
  $http,
  $q,
  $window,
  $injector,
  CacheConstants,
  CachedArrayDataFactory,
  $uibModal,
  TranslateProviderService,
  ChangeActiveOrderAction,
  JobLoadFailedAction,
  ErrorLogService,
  FlightRecorderService,
  $rootScope,
  $timeout
) {
  // MLC - 683 2016.09.09 MarkN
  // JobStore will now include a collection of Jobs instead of just a single job
  // Changes throughout this file
  let jobContext = [];
  let activeJobKey = null;
  const jobFailureKey = 'JOB_ERROR_FAILURE';
  const ORDER_TYPES = {
    PREORDER: 'PREORDER',
    REORDER: 'REORDER',
    PROOFORDER: 'PROOFORDER',
    PAYMENT: 'PAYMENT'
  };
  const SELLING_METHOD = {
    SPEC: 'SPEC',
    PREPAY: 'PREPAY',
    UNKNOWN: 'UNKNOWN'
  };

  function getStoredJobData(jobKey) {
    return StorageService.getData('jobData', jobKey, CacheConstants.jobDataOptions);
  }

  function getJobIndex(jobKey) {
    return jobContext.findIndex((item) => item.jobKey === jobKey);
  }

  // MLC-13293: the active job is tracked by jobKey rather than by position, so that
  // splicing jobContext (see removeJobContextByJobKey) cannot silently retarget or
  // orphan it. A dangling key resolves to undefined, i.e. "no active job".
  function getActiveJob() {
    return activeJobKey ? jobContext[getJobIndex(activeJobKey)] : undefined;
  }

  // Drops the active anchor and stops the data-dependent stores from serving a job that
  // is no longer in jobContext. Callers that have a replacement job go through
  // setActiveJobKey instead.
  const clearActiveJob = () => {
    activeJobKey = null;
    ProductCatalogStore.clearAll();
    VisualMerchandiseStore.clearAll();
    ActiveJobChangedAction.dispatch();
  };
  this.subjectStore = () => $injector.get('ShoppingCartStore');

  function containsAPkg(productCatalog) {
    return ProductCatalogStore.containsAPkg(productCatalog);
  }

  function validatePictureDayData(pictureDayData) {
    var returnVal = true;
    if (pictureDayData) {
      pictureDayData.firstName = pictureDayData.firstName || pictureDayData.subjectFirstName;
    }
    if (
      !pictureDayData ||
      (!pictureDayData.pictureDayId && !pictureDayData.portraitId) ||
      (pictureDayData.portraitId && !pictureDayData.accessCode)
    ) {
      MessageStore.createSystem(jobFailureKey);
      returnVal = false;
    }
    return returnVal;
  }

  function getJobIndexByPictureDayData(pictureDayData) {
    if (!validatePictureDayData(pictureDayData)) {
      return -1;
    }
    if (pictureDayData.pictureDayId) {
      return R.findIndex(function (job) {
        return job.jobNumber === pictureDayData.pictureDayId && job.portraitId === null;
      })(jobContext);
    } else {
      return R.findIndex(function (job) {
        return (
          job.jobKey ===
          pictureDayData.portraitId + pictureDayData.accessCode + (!!pictureDayData.specReorder ? 'SpecReorder' : '')
        );
      })(jobContext);
    }
  }
  this.getStoredAllJobsData = () => {
    return StorageService.getData('jobData') || [];
  };

  /**
   * Returns a map of all jobs' addOns organized by eventId (jobNumber) and skuCode
   * @returns {{}} Map structure: { eventId: { skuCode: addOnItem, ... }, ... }
   */
  this.getStoredAllJobsDataAsMap = () => {
    const allJobs = this.getStoredAllJobsData();
    const result = {};

    allJobs.forEach((job) => {
      const eventId = job.jobContext.jobNumber;
      const itemsMap = {};

      job.productCatalog.addOns.forEach((addOn) => {
        itemsMap[addOn.skuCode] = addOn;
      });
      job.productCatalog.packages.forEach((pkg) => {
        itemsMap[pkg.skuCode] = pkg;
      });
      job.productCatalog.bundles.forEach((bundle) => {
        itemsMap[bundle.skuCode] = bundle;
      });

      result[eventId] = itemsMap;
    });

    return result;
  };

  const refreshRelatedStores = () => {
    FlightRecorderService.log(`JobStore:refreshRelatedStores:${activeJobKey}`);
    const activeJob = getActiveJob();
    const data = getStoredJobData(activeJob.jobKey);
    ProductCatalogStore.loadProductCatalog(data.productCatalog, activeJob.jobKey);
    LooksStore.refresh(null, null); // needs revisit
    VisualMerchandiseStore.loadVisualMerchandise(data.visualMerchandise, activeJob.jobKey);
    this.getRouterService().translateSkuSetRoute();
  };

  this.updateJobData = function (jobData, masterSubject, pictureDayData) {
    jobData.jobContext.pictureDayExpirationDate = jobData.pictureDayExpirationDate;
    jobData.jobContext.claimExpirationDate = jobData.claimExpirationDate;
    jobData.jobContext.masterSubject = masterSubject;
    jobData.jobContext.containsAPkg = containsAPkg(jobData.productCatalog);
    jobData.jobContext.pcbCompatible = this.getContentStore().isPcbCompatible(jobData);
    jobData.jobContext.imageAuthorization = jobData.imageAuthorization;
    // MLC-13290: stamped at load and never refreshed, so it measures the job's age rather than its
    // last use — StorageService discards jobs past the max age even when activity kept the idle
    // clock alive. Client clock on both ends (see StorageService._hasExpiredJob): the comparison
    // runs in the browser, so a server stamp would inherit the skew between the two clocks.
    jobData.jobContext.loadedAt = new Date().getTime();
    if (pictureDayData) {
      if (!!pictureDayData.portraitId && !!pictureDayData.accessCode) {
        jobData.jobContext.portraitId = pictureDayData.portraitId;
        jobData.jobContext.accessCode = pictureDayData.accessCode;
        jobData.jobContext.jobKey =
          pictureDayData.portraitId + pictureDayData.accessCode + (!!pictureDayData.specReorder ? 'SpecReorder' : '');
      } else {
        jobData.jobContext.portraitId = null;
        jobData.jobContext.accessCode = null;

        jobData.jobContext.jobKey = jobData.jobContext.jobNumber;
      }
    }

    return jobData;
  };

  this.getJobData = function (jobKey) {
    return getStoredJobData(jobKey);
  };

  this.clearAll = function (itemKey) {
    FlightRecorderService.log('JobStore:clearAll');
    activeJobKey = null;
    // data-dependent stores
    LooksStore.clearAll(itemKey);
    ProductCatalogStore.clearAll();
    VisualMerchandiseStore.clearAll();
    SelectionTemplateDataStore.clearAll();

    jobContext = [];
    StorageService.setData('jobData', []);
  };

  this.handleErrors = function (data, status) {
    JobLoadFailedAction.dispatch();
    if (status === 0) {
      MessageStore.createSystem('CHECK_CONNECTION');
    } else if (!!data && !!data.error && data.error.code === 'LMI_UNAVAILABLE_ERROR') {
      MessageStore.createGrowler(data.error.code, '', 'error');
    } else if (!!data && !!data.error && data.error.code === 'LMI_CLAIM_NOT_ALLOWED') {
      MessageStore.createSystem(data.error.code);
    } else if (!!data && !!data.error && data.error.code === 'AUTHENTICATION_REQUIRED') {
      MessageStore.createSystem(data.error.code);
    } else if (!!data && !!data.error && data.error.code === 'IRIS_EXCEPTION') {
      MessageStore.createSystem('COMMON_TEXT_ERROR');
    } else if (!!data && !!data.error && data.error.code === 'UNKNOWN_SELLING_METHOD') {
      MessageStore.createSystem(data.error.code);
    } else if (data && data.errors) {
      angular.forEach(
        data.errors,
        function (error) {
          var errorKey = error.key;
          if (errorKey === 'APO_Id_inactive_US_error' || errorKey === 'APO_Id_inactive_CA_error') {
            error.params = {
              link: error.params[0] + '#/findmypictureday'
            };
          }
          if (errorKey === 'PICTURE_DAY_PAST') {
            errorKey = 'JOB_NOT_FOUND_ERROR';
          }
          if (errorKey === 'PHOTO_DAY_APO_CATEGORY_TYPE_EXCEPTION') {
            this.showPhotoDayDrawer();
            return;
          }
          MessageStore.createSystem(errorKey || jobFailureKey, error.params);
        }.bind(this),
        JobStore
      );
    } else {
      MessageStore.createSystem(jobFailureKey);
    }
  };

  this.loadJob = function (pictureDayData, specOrderFlow, isJobLoadingFromStudentBanner, source, options) {
    FlightRecorderService.log('JobStore:loadJob:start');
    const index = getJobIndexByPictureDayData(pictureDayData);
    $rootScope.openCopyOrderModalOnSubjectLoad = true;
    if (index >= 0) {
      this.setActiveJobKey(jobContext[index].jobKey);
      if (
        pictureDayData.pictureDayId ||
        (isJobLoadingFromStudentBanner &&
          (jobContext[index].sellingMethod !== SELLING_METHOD.SPEC ||
            (jobContext[index].sellingMethod === SELLING_METHOD.SPEC &&
              jobContext[index].orderType === ORDER_TYPES.REORDER)))
      ) {
        FlightRecorderService.log('JobStore:loadJob:dispatch_1');
        JobLoadedAction.dispatch(pictureDayData.firstName, pictureDayData.subjectRelationship);
        return $q.when(true);
      } else if (
        jobContext[index].sellingMethod !== SELLING_METHOD.SPEC ||
        (jobContext[index].sellingMethod === SELLING_METHOD.SPEC && jobContext[index].orderType === ORDER_TYPES.REORDER)
      ) {
        // all jobs with access credentials that are not spec family approval
        var ShoppingCartStore = $injector.get('ShoppingCartStore');
        var subject = ShoppingCartStore.getSubjectByJobKey(jobContext[index].jobKey);
        if (!!subject) {
          FlightRecorderService.log('JobStore:loadJob:dispatch_2');
          ChangeActiveOrderAction.dispatch();
        } else {
          FlightRecorderService.log('JobStore:loadJob:dispatch_3');
          JobLoadedAction.dispatch(pictureDayData.firstName, pictureDayData.subjectRelationship);
        }
        return $q.when(true);
      }
    }
    var url;
    var method;
    var data;

    if (!validatePictureDayData(pictureDayData)) {
      return $q.when(false);
    }

    if (pictureDayData.pictureDayId) {
      url = 'job/preorder/' + pictureDayData.pictureDayId + (source ? `?source=${source}` : '');
      method = 'GET';
      data = {};
    } else {
      var childGrade = pictureDayData.childGrade || pictureDayData.subjectGrade || '';
      url = 'job/reorder';
      method = 'POST';
      data = {
        //pass empty string as a failsafe in case this method is called by other parts of the application
        // that don't use subjectLastName
        subjectLastName: pictureDayData.subjectLastName || '',
        specOrderFlow: specOrderFlow || false,
        childGrade: childGrade,
        portraitId: pictureDayData.portraitId,
        accessCode: pictureDayData.accessCode
      };
      if (source) {
        data.source = source;
      }
      if (!childGrade) {
        sendEmptyGradeErrorLog();
      }
    }
    return $http({ method: method, url: url, data: data })
      .then(
        function (response) {
          let redirectUrl = response.data.redirect;
          const dateFromServer = response.headers().date;
          StorageService.setData('serverDate', dateFromServer);
          if (response.data.success && response.data.data.jobData) {
            if (options?.preventUpdatingJobData) {
              return response;
            }
            const jobData = this.updateJobData(
              response.data.data.jobData,
              response.data.data.masterSubject,
              pictureDayData
            );

            StorageService.setData('jobData', jobData, CacheConstants.jobDataOptions);
            this.storeJobData(jobData, null, null);
            FlightRecorderService.log('JobStore:loadJob:success');
            JobLoadedAction.dispatch(pictureDayData.firstName);
            return response;
          } else {
            if (!!redirectUrl) {
              const UserProfileStore = $injector.get('UserProfileStore');
              const isAuthenticated = UserProfileStore.isAuthenticated();
              function openRedirectModal() {
                const country = TranslateProviderService.isCanadianDomain() ? '_CA' : '';
                const modalInstance = $uibModal.open({
                  animation: true,
                  windowClass: 'modal-sm',
                  backdrop: 'static',
                  template:
                    '<lt-confirm-redirect ' +
                    'change-confirmation-message="REDIRECT_QUESTION' +
                    country +
                    '" ' +
                    'change-confirmation-description="REDIRECT_DESCRIPTION' +
                    country +
                    '" ' +
                    'confirmation-button-text="REDIRECT_BUTTON' +
                    country +
                    '" ' +
                    'cancellation-button-text="COMMON_TEXT_CANCEL" ' +
                    'close="modalCtrl.dismiss()" ' +
                    'redirect="modalCtrl.redirect()"> ' +
                    '</lt-confirm-redirect>',
                  controller: function () {
                    this.dismiss = function () {
                      modalInstance.close();
                      $injector.get('OrderFormService').goToSignIn();
                    };
                    this.redirect = function () {
                      if (!!pictureDayData.pictureDayId) {
                        redirectUrl += '#/pictureDayId/' + pictureDayData.pictureDayId;
                      } else {
                        redirectUrl +=
                          '#/accessCredentials/' + pictureDayData.portraitId + '/' + pictureDayData.accessCode;
                      }

                      $window.location.href =
                        redirectUrl + '?countryRedirect=true&firstName=' + (pictureDayData.firstName || '');
                    };
                  },
                  controllerAs: 'modalCtrl'
                });
              }
              if (isAuthenticated) {
                $rootScope.$broadcast('closeAddNewStudentPopup');
                $timeout(openRedirectModal, 100);
              } else {
                openRedirectModal();
              }
            } else {
              this.handleErrors(response.data);
            }
          }
          return response;
        }.bind(this)
      )
      .catch(
        function (response) {
          if (response instanceof Error) {
            ErrorLogService(response);
          }
          this.handleErrors(response.data, response.status);
        }.bind(this)
      );
  };

  this.showPhotoDayDrawer = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-photo-day-redirection ' +
        'on-cancel="modalCtrl.dismiss()" ' +
        'on-emit="modalCtrl.emit()"> ' +
        '</lt-photo-day-redirection>',
      controller: function () {
        this.dismiss = function () {
          modalInstance.close();
        };
        this.emit = function () {
          $window.open('https://my.photoday.com/', '_blank');
          modalInstance.close();
        };
      },
      controllerAs: 'modalCtrl'
    });
  };

  this.showPhotoDayDrawer = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-photo-day-redirection ' +
        'on-cancel="modalCtrl.dismiss()" ' +
        'on-emit="modalCtrl.emit()"> ' +
        '</lt-photo-day-redirection>',
      controller: function () {
        this.dismiss = function () {
          modalInstance.close();
        };
        this.emit = function () {
          $window.open('https://my.photoday.com/', '_blank');
          modalInstance.close();
        };
      },
      controllerAs: 'modalCtrl'
    });
  };

  this.setActiveJob = function (jobKey) {
    FlightRecorderService.log(`JobStore:setActiveJob:${jobKey}`);
    if (getJobIndex(jobKey) < 0) {
      MessageStore.createSystem(jobFailureKey);
      return;
    }
    this.setActiveJobKey(jobKey);
  };

  this.setActiveJobKey = function (jobKey) {
    FlightRecorderService.log(`JobStore:setActiveJobKey:${jobKey}`);
    activeJobKey = jobKey;
    refreshRelatedStores();
    ActiveJobChangedAction.dispatch();
  };

  this.removeJobContextByJobKey = function (jobKey) {
    const index = getJobIndex(jobKey);
    if (index >= 0) {
      const wasActive = activeJobKey === jobKey;
      jobContext.splice(index, 1);
      /**
       * Nate 2019: 9/23/2019: The initial method StorageService.SetData(jobkey) put in tries to delete at
       * the mlt.data.jobkey level not at the mlt.data.jobContext level where the job data is stored.
       * To fix this I added a new method that specifically looks at jobContext and removes the job by jobKey.
       */
      StorageService.removeJob(jobKey);

      // Only the removal of the active job needs to move the active pointer; removing any
      // other job leaves activeJobKey valid. Choosing the replacement job is not this
      // store's call — which job is active follows from which cart subject is selected —
      // so drop the anchor and let ShoppingCartStore re-anchor if a subject survives.
      if (wasActive) {
        clearActiveJob();
      }
    }
  };

  this.getJob = function (jobKey) {
    return jobKey ? jobContext[getJobIndex(jobKey)] : getActiveJob();
  };

  this.getJobBySubject = function (subject) {
    return this.getJob(subject.portraitDashboard.jobKey);
  };

  this.getJobByJobKey = function (jobKey) {
    var index = getJobIndex(jobKey);

    if (index === -1) {
      MessageStore.createSystem(jobFailureKey);
    }

    return jobContext[index];
  };

  this.hasJobsLoaded = function () {
    return jobContext.length > 0;
  };

  this.storeJobData = (data, mruLookNumbers, viewedLooksCategoryKeys) => {
    FlightRecorderService.log('JobStore:storeJobData');

    data.jobContext.season = this.getContentStore().getSeason(data.jobContext);

    updateJobContext(data.jobContext);
    activeJobKey = data.jobContext.jobKey;

    // data-dependent stores
    ProductCatalogStore.loadProductCatalog(data.productCatalog, activeJobKey);
    LooksStore.refresh(mruLookNumbers, viewedLooksCategoryKeys);
    VisualMerchandiseStore.loadVisualMerchandise(data.visualMerchandise, activeJobKey);
  };

  this.getJobs = function () {
    return jobContext;
  };

  this.isJobLoaded = function (jobNumber) {
    if (!jobNumber) {
      return !!getActiveJob();
    }
  };

  this.getClickSelection = function (jobKey) {
    var data = getStoredJobData(jobKey);
    return data.clickSelection;
  };

  this.getCaptureSessionId = function (jobKey) {
    var data = getStoredJobData(jobKey);
    return data.captureSessionId;
  };

  this.getAccessCredential = function (jobKey) {
    var data = getStoredJobData(jobKey);
    return data.accessCredential;
  };

  this.getProductCatalog = function (jobKey) {
    if (!jobKey) {
      jobKey = getActiveJob().jobKey;
    }
    const data = StorageService.getData('jobData', jobKey, CacheConstants.jobDataOptions);
    return data.productCatalog;
  };

  this.isPreOrder = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded() ? getActiveJob().orderType === ORDER_TYPES.PREORDER : true;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.PREORDER;
  };

  this.isShipToHome = function (jobKey) {
    if (!jobKey) {
      return !(this.isJobLoaded() ? this.isProofOrder() && !getActiveJob().shipToHome : false);
    }

    const jc = this.getJobByJobKey(jobKey);
    return !this.isProofOrder(jobKey) && jc.shipToHome;
  };

  this.getCurrency = function () {
    return getActiveJob().currency;
  };

  this.getCountry = function () {
    return getActiveJob()?.jobCountry;
  };

  this.isPayOnly = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded()
        ? getActiveJob().orderType === ORDER_TYPES.PAYMENT && getActiveJob().sellingMethod === SELLING_METHOD.PREPAY
        : false;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.PAYMENT && jc.sellingMethod === SELLING_METHOD.PREPAY;
  };

  this.getCreditCardKey = function () {
    return this.getCountry() === 'CAN' ? 'CREDIT_CARDS_CA' : 'CREDIT_CARDS_US';
  };

  this.getCardOptionsKey = function () {
    return this.getCountry() === 'CAN' ? 'CC_OPTIONS_CA' : 'CC_OPTIONS_US';
  };

  this.isEnhancedPayOnly = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded()
        ? getActiveJob().orderType === ORDER_TYPES.PAYMENT &&
            getActiveJob().containsAPkg &&
            getActiveJob().sellingMethod === SELLING_METHOD.SPEC
        : false;
    }
    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.PAYMENT && jc.sellingMethod === SELLING_METHOD.SPEC && jc.containsAPkg;
  };

  this.isEnhancedReorder = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded()
        ? getActiveJob().orderType === ORDER_TYPES.REORDER &&
            getActiveJob().containsAPkg &&
            getActiveJob().sellingMethod === SELLING_METHOD.SPEC
        : false;
    }
    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.REORDER && jc.sellingMethod === SELLING_METHOD.SPEC && jc.containsAPkg;
  };

  this.isReorder = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded() ? getActiveJob().orderType === ORDER_TYPES.REORDER : false;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.REORDER;
  };

  this.isProofOrder = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded() ? getActiveJob().orderType === ORDER_TYPES.PROOFORDER : false;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc.orderType === ORDER_TYPES.PROOFORDER;
  };

  this.isReorderGroupOnly = function (jobKey) {
    const jobData = getStoredJobData(jobKey || getActiveJob().jobKey);
    return jobData?.subjectDetails?.isGroupOnlyCaptureSession || false;
  };

  this.isSpectrumPayOnly = function () {
    return this.isJobLoaded() ? getActiveJob().spectrumEnabled && getActiveJob().paymentOnlyFlow : false;
  };

  this.getSellingMethod = function () {
    return this.isJobLoaded() ? getActiveJob().sellingMethod : null;
  };

  this.getSubProgramName = function () {
    return this.isJobLoaded() ? getActiveJob().jobName : null;
  };

  this.getSchoolYear = function () {
    return this.isJobLoaded() ? getActiveJob().schoolYearDisplay : null;
  };
  this.getEventDate = function () {
    return this.isJobLoaded() ? getActiveJob().eventDate : null;
  };
  this.getOrderType = function () {
    return this.isJobLoaded() ? getActiveJob().orderType : null;
  };

  this.isUnderclass = function (jobKey) {
    const underClassJobs = this.getConfig().underclassSubPrograms || [];
    if (!jobKey) {
      return this.isJobLoaded() ? underClassJobs.includes(getActiveJob().jobName) : false;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc && underClassJobs.includes(jc.jobName);
  };

  this.isClassRoomGroup = function (jobKey) {
    if (!jobKey) {
      return this.isJobLoaded() ? getActiveJob().jobName.toUpperCase() === 'CLASSROOM GROUPS' : false;
    }

    const jc = this.getJobByJobKey(jobKey);
    return jc.jobName.toUpperCase() === 'CLASSROOM GROUPS';
  };

  this.onDeserialized = function (type, data) {
    FlightRecorderService.log('JobStore:onDeserialized');
    var thisStoreJobData = this.storeJobData,
      storeData = function (item) {
        thisStoreJobData(item, data.mostRecentlyUsedLooks, data.viewedLooksCategoryKeys);
      };

    if (!!data && !!data.jobData) {
      R.forEach(storeData, data.jobData);
    }
  };

  this.getConfig = function () {
    return this.getContentStore().getConfig();
  };

  this.getContentStore = function () {
    return $injector.get('ContentStore');
  };

  this.getRouterService = function () {
    return $injector.get('RouterService');
  };

  this.isInPilot = (pilotName) => this.getJob().pilots.includes(pilotName);

  function sendEmptyGradeErrorLog() {
    var error = new Error();
    error.message =
      'JobStore.reorder grade is empty! ' +
      JSON.stringify({
        route: StorageService.get('data.router')
      });
    ErrorLogService(error);
  }

  function updateJobContext(data) {
    const index = getJobIndex(data?.jobKey);

    if (index === -1) {
      jobContext.push(data);
      return;
    }

    jobContext[index] = data;
  }

  this.getCurrentSeason = () => {
    const allJobsHaveSameSeason = this.allJobsHaveIdenticalSeasons();
    return allJobsHaveSameSeason && this.getJobs()[0]?.season;
  };

  this.allJobsHaveIdenticalSeasons = () => {
    const jobs = this.getJobsForActiveSubjects();
    const subprogramNames = jobs.map((job) => job?.season?.subprogramName);
    const years = jobs.map((job) => job?.season?.year);

    return new Set(subprogramNames).size === 1 && new Set(years).size === 1;
  };

  this.getSubtotalAfterDiscounts = function () {
    const ShoppingCartStore = $injector.get('ShoppingCartStore');
    return ShoppingCartStore.getSubtotalAfterDiscounts();
  };

  this.getJobsForActiveSubjects = function () {
    const ShoppingCartStore = $injector.get('ShoppingCartStore');
    const subjects = ShoppingCartStore.getSubjects();

    return this.getStoredAllJobsData().filter((job) =>
      subjects.some((sub) => sub.jobContext?.jobNumber === job.jobContext.jobNumber)
    );
  };

  this.getAvailableEnhancementsByJobNumber = (jobNumber) => {
    const job = this.getStoredAllJobsData().find((job) => job.jobContext.jobNumber === jobNumber);
    return job?.productCatalog.upgrades || [];
  };

  this.getEnhancementsInPackageByJob = (jobIdentifier, pkg) => {
    const job = this.getStoredAllJobsData().find(
      (job) => job.jobContext.jobNumber === jobIdentifier || job.jobContext.jobKey === jobIdentifier
    );
    const packages = job?.productCatalog.packages || [];
    return packages.find((p) => p.skuCode === (pkg.basePackage || pkg.skuCode))?.upgrades || [];
  };

  this.getSuggestedAddOns = function () {
    const subjects = this.subjectStore().getSubjects();
    const pricedAddons = this.getPricedAddons(subjects);
    const addonsBySkuSet = this.getSuggestedSkuSets().reduce((acc, skuSet) => {
      acc[skuSet.name] = pricedAddons.filter(({ addon }) => skuSet.skus.includes(addon.skuCode));
      return acc;
    }, {});

    return [
      ...new Map(
        Object.values(addonsBySkuSet)
          .filter((addons) => addons.length === subjects.length)
          .filter((addons) => this.haveSinglePrice(addons))
          .flat()
          .map(({ addon }) => [addon.skuCode, addon])
      ).values()
    ];
  };

  this.getPricedAddons = (subjects) => {
    const jobData = this.getStoredAllJobsData();

    return subjects.flatMap((subject) => this.getPricedAddonsBySubject(jobData, subject));
  };

  this.getPricedAddonsBySubject = (jobData, subject) => {
    return this.getAddons(jobData, subject).map((addon) => ({
      price: this.getAddonPrice(addon, subject),
      addon: addon
    }));
  };

  this.getAddons = (jobData, subject) => {
    const job = jobData.find((job) => subject.jobContext?.jobNumber === job.jobContext.jobNumber);

    return (job?.productCatalog.addOns || []).filter((addOn) => !addOn.lookSelectionAllowed);
  };

  this.getAddonPrice = (addon, subject) =>
    subject.packages.length > 0 ? addon.discountedPriceWithPackage : addon.unitPrice;

  this.getSuggestedSkuSets = () => {
    const subtotal = this.getSubtotalAfterDiscounts();

    return this.getContentStore().getFreeShippingMeterUpsellsSkus(subtotal);
  };

  this.getProductSkuSetsAsList = () => this.getContentStore().getProductSkuSetsAsList();

  this.haveSinglePrice = (addons) => {
    const [{ price }] = addons;

    return addons.every((addon) => addon.price === price);
  };

  /**
   * Searches through each job's product catalog to find compatible items for given item and skuSets
   * Returns a map of event and item that's compatible with sourceItem
   * @param sourceItem The source item (addon/bundle/package) to find compatible items for
   * @param skuSets An array of skuSets, uses the first skuset that contains the sourceItem's skuCode
   * @returns {{}} A map of eventId to item, or empty object if none found
   */
  this.getEventItemMapForSkuSets = (sourceItem, skuSets) => {
    const result = {};
    const matchingSkuSets = skuSets.filter((skuSet) => skuSet.skus.includes(sourceItem.skuCode));

    if (!matchingSkuSets.length) {
      console.warn(`JobStore.getEventItemMapForSkuSets: no skuSets found for source item ${sourceItem.skuCode}`);
      return {};
    }

    if (matchingSkuSets.length > 1) {
      console.warn(`JobStore.getEventItemMapForSkuSets: multiple skuSets found for source item ${sourceItem.skuCode}`);
    }

    const selectedSkus = matchingSkuSets[0].skus;
    const allJobsMap = this.getStoredAllJobsDataAsMap();

    Object.entries(allJobsMap).forEach(([eventId, itemsMap]) => {
      let foundItem = itemsMap[sourceItem.skuCode];

      if (!foundItem) {
        const foundSkuCode = selectedSkus
          .filter((sku) => sourceItem.skuCode !== sku)
          .find((skuCode) => itemsMap[skuCode]);

        if (foundSkuCode) {
          foundItem = itemsMap[foundSkuCode];
        }
      }

      if (!foundItem) {
        console.warn(
          `JobStore.getEventItemMapForSkuSets: could not find compatible add on for job ${eventId} and source item ${sourceItem.skuCode}`
        );
        return;
      }

      if (result[eventId]) {
        console.warn(
          `JobStore.getEventItemMapForSkuSets: duplicate job number found ${eventId} and source item ${sourceItem.skuCode}`
        );
        return;
      }

      result[eventId] = foundItem;
    });

    return result;
  };

  this.getSuggestedUpsellEventItemMapByAddon = (addOn) => {
    return this.getEventItemMapForSkuSets(addOn, this.getSuggestedSkuSets());
  };

  LogoutSuccessAction.register(this.clearAll.bind(this));
  DeserializeAction.register(this.onDeserialized.bind(this));
}

App.service('JobStore', [
  'MessageStore',
  'LooksStore',
  'ProductCatalogStore',
  'VisualMerchandiseStore',
  'SelectionTemplateDataStore',
  'SessionTimeoutAction',
  'LogoutSuccessAction',
  'JobLoadedAction',
  'DeserializeAction',
  'ActiveJobChangedAction',
  'ResetJobAction',
  'EmptyCartAction',
  'StorageService',
  '$http',
  '$q',
  '$window',
  '$injector',
  'CacheConstants',
  'CachedArrayDataFactory',
  '$uibModal',
  'TranslateProviderService',
  'ChangeActiveOrderAction',
  'JobLoadFailedAction',
  'ErrorLogService',
  'FlightRecorderService',
  '$rootScope',
  '$timeout',
  JobStore
]);
